<template>
  <div id="main" style="margin:0 auto;height:100%;">
    <div class="chartDiv" style="margin-top: 2%" align="center">
      <highcharts :options = 'options' style="width: 100%"></highcharts>
    </div>
    <!-- <div class="block" style="margin-top: 2%" align="center">
      <span class="demonstration">选择查询时间段</span><br/>
      <el-date-picker
        v-model="value5"
        type="datetimerange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions2">
      </el-date-picker>
    </div>
    <div style="margin-top: 2%" align="center">
      <el-button v-on:click="query" type="primary" style="background-color: #004499; border-color: #004499">Draw Line Chart</el-button>
      <el-button @click="showData" type="primary" style="background-color: #004499; border-color: #004499">View Data</el-button>
    </div> -->
  </div>
</template>

<script>
    import FileSaver from 'file-saver'
    import XLSX from 'xlsx'
    export default {
      name: "integralcurrquery",
      chartSettings: {
        labelMap: {}
      },
      watch:{
        chartTime1(){
          this.query()
        }
      },
      props:{
        chartTime1:{
          type:String,
          default:''
        },
        chartTime2:{
          type:String,
          default:''
        },
        chartPvName:{
          type:String,
          default:''
        }
      },
      data() {
        return {
          totalValue:0,
          pageNumber:0,
          pageSize:50,
          currentPage:1,
          pickerOptions2: {
            shortcuts:[{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
          },
          value5: [new Date(Date.now() - 3600 * 24 * 1000 *30), new Date(Date.now())],
          options: {
            chart: {
              type:'scatter',
              backgroundColor: '#eef3f7',
              width: 550,
              height: 300,
              // zoomType: 'x',
              resetZoomButton: {
                position: {
                  // align: 'right', // by default
                  // verticalAlign: 'top', // by default
                  x: 0,
                  y: -30
                },
                relativeTo: 'chart',
                animation:false
              },
              plotBorderWidth: 2,
              plotBorderColor: 'grey'
            },
            plotOptions: {
              animation:false,
              series:{
                turboThreshold:10000,
                point:{
                events:{
                  click:this.getArrayDataEmit
                }
              }
              },
              line: {
                dataGrouping: {
                  enabled: false
                }
              }
            },
            title: {
              // text: 'Time'
            },
            xAxis: {
              lineWidth:1,
              gridLineDashStyle:'ShortDash',
              lineColor:'grey',
              gridLineWidth: 1,
              ordinal:false,
              title:{
                text:'',
                style: {
                  color:"black",
                  fontWeight:1000
                }
              },
              type: 'datetime',
              dateTimeLabelFormats: {
                millisecond: '%H:%M:%S.%L',
                second: '%H:%M:%S',
                minute: '%H:%M',
                hour: '%H:%M',
                day: '%m-%d',
                week: '%m-%d',
                month: '%Y-%m-%d',
                year: '%Y'
              }
            },
            yAxis: [{
              step:10,
              showFirstLabel:true,
              showLastLabel:true,
              opposite:false,
              type: 'scatter',
              lineColor:'grey',
              title: {
                text: 'Time'
              },
              lineWidth:0
            },{
              opposite:true,
              lineWidth:0,
              lineColor:'grey',
            }],
            tooltip: {
              dateTimeLabelFormats: {
                millisecond: '%H:%M:%S.%L',
                second: '%H:%M:%S',
                minute: '%H:%M',
                hour: '%H:%M',
                day: '%Y-%m-%d',
                week: '%m-%d',
                month: '%Y-%m-%d',
                year: '%Y'
              }
            },
            credits: {
              enabled:false,
            },
            rangeSelector: false,
            legend: {
              enabled: true,
              verticalAlign: 'bottom',
              // layout: 'vertical',
              align: 'middle'
            },
            series:[{
              name:'Time',
              data:[],
              lineWidth:0,
              yAxis:0,
              color: "#FF0000",
              showInLegend:false
            }]
          },
          dialogTableVisible: false,
          gridData: [],

          statisticsDialogTableVisible:false,
          statisticsData:[],
          timeArray:[],
          time1:null
        }
      },
      mounted(){
        let p = new Array();
        let q = new Array();
        let n;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        let time1 = new Date(date1.format("yyyy-MM-dd")).format('yyyy-MM-dd hh:mm:ss')
        this.time1 = time1
        let time2 = new Date(date2.format("yyyy-MM-dd")).format('yyyy-MM-dd hh:mm:ss')
        let _this = this
        this.$axios.get("/hlsTS/history_timepoint1/name/"+ "SR-BD-DBPM01:bpm1:fa.X" + "/" + time1 + "/" + time2).then(function (response){
          n = response.data.length;
          for (var i = 0; i < n; i++){
            let obj = {
              timestamp:response.data[i].timestamp,
              nanosecs:response.data[i].nanosecs
            }
            p.push([_this.shijianchuo(obj.timestamp),Math.floor(Math.random() * 1)])
          }
          // _this.options.series[0].data=p;
          _this.timeArray = p;
        });
      },
      methods:{
        query: function () {
          let p = new Array();
          let q = new Array();
          let n;
          // let date1 = new Date(this.value5[0]);
          // let date2 = new Date(this.value5[1]);
          // let time1 = new Date(date1.format("yyyy-MM-dd") + " 00:00:00").format('yyyy-MM-dd hh:mm:ss')
          // let time2 = new Date(date2.format("yyyy-MM-dd") + " 00:00:00").format('yyyy-MM-dd hh:mm:ss')
          let _this = this
          this.$axios.get("/hlsTS/history_timepoint1/name/"+ "SR-BD-DBPM01:bpm1:fa.X" + "/" + _this.chartTime1 + "/" + _this.chartTime2).then(function (response){
            n = response.data.length;
            for (var i = 0; i < n; i++){
              let obj = {
                timestamp:response.data[i].timestamp,
                nanosecs:response.data[i].nanosecs
              }
              p.push([_this.shijianchuo(obj.timestamp),Math.floor(Math.random() * 1)])
            }
          _this.options.series[0].data=p;
          });
        },
        showData:function () {
         this.dialogTableVisible = true;
          let p = new Array();
          let q = new Array();
          let n;
          let total = 0;
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let time1 = new Date(date1.format("yyyy-MM-dd") + " 00:00:00").format('yyyy-MM-dd hh:mm:ss')
          let time2 = new Date(date2.format("yyyy-MM-dd") + " 00:00:00").format('yyyy-MM-dd hh:mm:ss')
          let _this = this
          this.$axios.get('/hlsTS/integral/'+time1+'/'+time2).then(function (response){
            n = response.data.length;
            for (var i = 0; i < n; i++){
              q.push({
                curr_date:(new Date(response.data[i].curr_date)).format("yyyy-MM-dd").toString(),
                val:response.data[i].val.toFixed(6)
              })
            }
            _this.gridData = q;
            for (var i = 0; i < n; i++){
              total += response.data[i].val;
            }
            _this.totalValue = total.toFixed(6);
          });
        },
        shijianchuo:function(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        },
        getArrayDataEmit:function(e){
          let nanosecs = null ;
          let _this = this
          _this.timeArray.forEach((item,key)=>{
            if(item.timestamp == e.point.x){
              nanosecs = item.nanosecs
            }
          })
          nanosecs =  "648943243";
          let data = {
            nanosecs:nanosecs,
            // time1:_this.time1
            time1:'2024-09-21 23:00:18'
          }
          _this.$emit('getData',data)
        }
      }
    }
</script>

<style scoped>
    div{
      margin-left: auto;
      margin-right: auto;
      font-size: small;
    }
    .el-table-column{
      align:center;
    }
</style>



// WEBPACK FOOTER //
// src/page/activePublic/chartTime.vue